import { SaveHeroSection } from "components/UI/molecules";
import { SHOP_NOW_SECTIONS } from "./utils/content";

export const ShopNowList = () => {
  return SHOP_NOW_SECTIONS.map((item) => (
    <SaveHeroSection key={item.id} {...item} />
  ));
};
